// Hooks / Node modules / Styles
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons
import routes from "src/data/routes";

function TitleBar({ overrideTitle, children }) {
  const location = useLocation();
  const [title, setTitle] = useState("");

  useEffect(() => {
    const currentRoute = routes.find(
      (route) => route.path === location.pathname
    );

    setTitle(currentRoute ? currentRoute.name : "");
  }, [location.pathname]);

  return (
    <div className="pt-0 pb-5 flex flex-row items-center justify-between">
      <div className="text-4xl font-bold local-theme-text-md">{overrideTitle ? overrideTitle : title}</div>

      <div>{children}</div>
    </div>
  );
}

export default TitleBar;
